var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticClass: "create-evaluation-modal",
      attrs: { title: "撤回测评", visible: _vm.visible },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [_c("div", { staticClass: "text" }, [_vm._v("您确定要撤回这个测评吗？")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }